import React from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@metarouter-private/mr-mui';

import CreateSampleEventAction from 'app/shared/components/sample-events/CreateSampleEventAction';

import SampleEventSelect from './SampleEventSelect';
import ManageSampleEventsButton from './ManageSampleEventsButton';

export default function SampleEventControls({
  currentValue,
  selectedSampleEventId,
  loadSampleEvent,
  onOpenManageModal,
}) {
  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
      <SampleEventSelect
        selectedSampleEventId={selectedSampleEventId}
        loadSampleEvent={loadSampleEvent}
        currentValue={currentValue}
      />

      <Stack direction="row" alignItems="center">
        <CreateSampleEventAction sampleEventJson={currentValue} buttonSize="medium" />

        <ManageSampleEventsButton onClick={onOpenManageModal} />
      </Stack>
    </Stack>
  );
}

SampleEventControls.propTypes = {
  currentValue: PropTypes.string,
  selectedSampleEventId: PropTypes.string,
  loadSampleEvent: PropTypes.func.isRequired,
  onOpenManageModal: PropTypes.func.isRequired,
};
